import { render } from "./AdministratorOneLessonContent.vue?vue&type=template&id=2f38cb29&scoped=true"
import script from "./AdministratorOneLessonContent.vue?vue&type=script&lang=js"
export * from "./AdministratorOneLessonContent.vue?vue&type=script&lang=js"

import "./AdministratorOneLessonContent.vue?vue&type=style&index=0&id=2f38cb29&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f38cb29"]])

export default __exports__